module.exports = __webpack_public_path__ + "static/media/10.502364cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/thumbs/10.jpg
// module id = 149
// module chunks = 0